/** @deprecated */
export { MdProgressSpinner as MdProgressCircle } from './progress-spinner';
/** @deprecated */
export { MdProgressSpinnerModule as MdProgressCircleModule } from './progress-spinner';
//# sourceMappingURL=progress-circle.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/progress-spinner/progress-circle.js
// module id = ../../../material/progress-spinner/progress-circle.js
// module chunks = 3